import React from 'react';
import { Card, Statistic } from 'antd';

interface StatusCardProps {
  title: string;
  count: number;
  isLoading: boolean;
  className: string;
  onClick: () => void;
}

const StatusCard: React.FC<StatusCardProps> = ({ title, count, className, isLoading, onClick }) => {
  return (
    <Card className={className} onClick={onClick}>
      <div className="card-content">
        {!isLoading && <Statistic  title={title} value={count} valueStyle={{ fontSize: '36px', color: '#3f8600' }}   />}
        {isLoading && <Statistic  title={title} loading={true} value={count} valueStyle={{ fontSize: '36px', color: '#3f8600' }}   />}
        
      </div>
    </Card>
  );
};

export default StatusCard;
